import { InventoryCard as Page, InventoryCardHeader as Header } from './ui';

export const InventoryCard = { Page, Header };
